import { getAdsListRequest, getAdRequest, deleteAdRequest, saveAdRequest } from "../../requests/ads";
export const types = {
  GET_ADS_LIST_REQUEST: 'GET_ADS_LIST_REQUEST',
  GET_ADS_LIST_SUCCESS: 'GET_ADS_LIST_SUCCESS',
  GET_ADS_LIST_FAILURE: 'GET_ALL_ADS_FAILURE',
  GET_SINGLE_AD_REQUEST: 'GET_SINGLE_AD_REQUEST',
  GET_SINGLE_AD_SUCCESS: 'GET_SINGLE_AD_SUCCESS',
  GET_SINGLE_AD_FAILURE: 'GET_SINGLE_AD_FAILURE',
  SAVE_AD_REQUEST: 'SAVE_AD_REQUEST',
  SAVE_AD_SUCCESS: 'SAVE_AD_SUCCESS',
  SAVE_AD_FAILURE: 'SAVE_AD_FAILURE',
  DELETE_AD_REQUEST: 'DELETE_AD_REQUEST',
  DELETE_AD_SUCCESS: 'DELETE_AD_SUCCESS',
  DELETE_AD_FAILURE: 'DELETE_AD_FAILURE'
}
export const requests = {
  SAVE_AD_REQUEST: saveAdRequest
}
export const getAdsList = (channelId) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_ADS_LIST_REQUEST
    })
    getAdsListRequest(channelId)
      .then(response => {
        dispatch({
          type: types.GET_ADS_LIST_SUCCESS,
          data: response.data
        })
      })
  }
}

export const getAd = id => {
  return (dispatch) => {
    dispatch({
      type: types.GET_SINGLE_AD_REQUEST,
      id
    })
    getAdRequest(id)
      .then(response => {
        dispatch({
          type: types.GET_SINGLE_AD_SUCCESS,
          data: response
        })
      })
      .catch(err => {
        dispatch({
          type: types.GET_SINGLE_AD_FAILURE,
          data: err
        })
      })
  }
}

export const deleteAd = ad => {
  return (dispatch) => {
    dispatch({
      type: types.DELETE_AD_REQUEST,
      data: ad
    })
    deleteAdRequest(ad.id)
      .then(response => {
        dispatch({
          type: types.DELETE_AD_SUCCESS,
          data: ad
        })
      })
      .catch(err => {
        dispatch({
          type: types.DELETE_AD_FAILURE,
          data: ad,
          error: err
        })
      })
  }
}